/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useContext, useState, useMemo } from 'react'
import { headerFreightTable, mock } from './utils'
import { format } from 'date-fns'
import {
  HeaderRow,
  ItemRow,
  HeaderCell,
  ItemCell,
  ItemCellContainer,
  ImageCell,
  OptionsImage,
  StatusText,
} from './style'
import { TableContainer } from '../style'

import details from '../../../../assets/router/details.svg'
import edit from '../../../../assets/router/edit-pen.svg'
import trash from '../../../../assets/router/trash.svg'
import ModalContext from '../../../../contexts/ModalContext'
import { FreightContext, Freight } from '../../../../contexts/FreightContext'
import axios from '../../../../config/axios'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { RouterOutletType } from '../index2'
import SectionContext from '../../../../contexts/SectionContext'
import {
  GlobalTable,
  HeaderLine,
  Td,
  TdButtons,
  Th,
  Tr,
} from '../../../../components/styles/table-style'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import TableFiltersContext from '../../../../contexts/TableFiltersContext'
import { TypeMainOutlet } from '../..'

interface FreightTableType {
  onChange?: () => void
}

const FreightTable: React.FC<FreightTableType> = (props) => {
  const { freight, setFreight } = useContext(FreightContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { setRouterSection } = useContext(SectionContext)
  const [freights, setFreights] = useState<Freight[]>([])
  const [totalFreights, setTotalFreights] = useState<number | null>(null)
  const [page, setPage] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const { setFeedback } = useContext(FeedbackContext)
  const navigate = useNavigate()
  const { search, appliedFilters } = useOutletContext<RouterOutletType>()
  const tratadorDeErro = {
    type: '',
    detail: '',
    deadLine: '',
    address: {
      street: '',
      number: '',
      complement: '',
      cep: 0,
      neighborhood: {
        name: '',
        city: {
          name: '',
          state: {
            name: '',
            uf: '',
          },
        },
      },
    },
    load: {
      height: '',
      width: '',
      length: '',
      cubage: '',
      weight: '',
    },
  }
  const { freightStatusFilter } = useContext(TableFiltersContext)
  const [duplicatedIds, setDuplicatedIds] = useState<number[]>([])

  useEffect(() => {
    const idsRaw = sessionStorage.getItem('duplicatedFreights')
    const ids = idsRaw ? JSON.parse(idsRaw) : []

    if (ids.length > 0) {
      setDuplicatedIds(ids)
    }
    sessionStorage.removeItem('duplicatedFreights')
  }, [freightStatusFilter, search])

  const dateHourFormatter = (isoDateString: string) => {
    const date = new Date(isoDateString)

    // Extrai os componentes da data
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // Mês é de 0 a 11, então somamos 1
    const year = date.getFullYear()

    // Calcula o horário de Brasília (UTC-3)
    const brasiliaOffset = -3
    const utcHours = date.getUTCHours()
    const brasiliaHours = utcHours + brasiliaOffset

    // Lógica para lidar com a virada do dia (se o horário de Brasília for negativo)
    const finalHours = brasiliaHours < 0 ? 24 + brasiliaHours : brasiliaHours
    const finalMinutes = String(date.getUTCMinutes()).padStart(2, '0')

    // Retorna a string formatada
    return `dia ${day}/${month}/${year} às ${String(finalHours).padStart(
      2,
      '0',
    )}:${finalMinutes}`
  }
  const dataFormatter = (isoDateString: string): string => {
    if (!isoDateString) {
      return '' // Retorna vazio se a string for nula ou vazia
    }

    const dateUtc = new Date(isoDateString)

    // Verifica se a data é válida antes de tentar formatar
    if (isNaN(dateUtc.getTime())) {
      console.error('Data ISO inválida recebida:', isoDateString)
      return '' // Trata o caso de uma string de data inválida
    }

    // Extrai as partes da data diretamente do UTC
    const year = dateUtc.getUTCFullYear()
    const month = dateUtc.getUTCMonth() + 1 // getUTCMonth é 0-indexado, então adiciona 1
    const day = dateUtc.getUTCDate()

    // Garante que mês e dia tenham dois dígitos (ex: 01 em vez de 1)
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day

    return `${formattedDay}/${formattedMonth}/${year}`
  }

  const handleEditFreight = async (id: number) => {
    //  setModalActive(true)
    //  setModalSection('routerFreightForm')
    setFreight(await getFreight(id))
    navigate('create')
  }

  const handleViewFreight = async (id: number) => {
    // setModalActive(true)
    // setModalSection("routerFreightDetail")
    setFreight(await getFreight(id))
    navigate(`${id}`)
  }
  const getFreight = async (id: number): Promise<Freight> => {
    const response = await axios.get(
      `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/${id}`,
    )
    return response.data as Freight
  }

  const getFreights = async (
    pageNumber: number,
    statusFilter: string | null = null,
    search: string | null = null,
  ) => {
    try {
      const token = localStorage.getItem('token')
      let url = `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight?page=${pageNumber}&size=50`
      if (statusFilter && statusFilter !== 'Todos') {
        url += `&status=${encodeURIComponent(statusFilter)}`
      }
      if (search) {
        url += `&search=${encodeURIComponent(search)}`
      }
      if (appliedFilters && appliedFilters.length > 0) {
        url += `&filters=${encodeURIComponent(JSON.stringify(appliedFilters))}`
      }
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        }
      )
      try {
        let countUrl = `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/route/freights/count?1=1`
        if (statusFilter && statusFilter !== 'Todos') {
          countUrl += `&status=${encodeURIComponent(statusFilter)}`
        }
        if (search) {
          countUrl += `&search=${encodeURIComponent(search)}`
        }
        if (appliedFilters && appliedFilters.length > 0) {
          countUrl += `&filters=${encodeURIComponent(JSON.stringify(appliedFilters))}`
        }
        const countResp = await axios.get(countUrl, { headers: { Authorization: `Bearer ${token}` } })
        setTotalFreights(countResp.data?.total ?? null)
      } catch (err) {
        setTotalFreights(null)
      }
      return response.data as Freight[]
    } catch (error) {
      console.error('Erro ao buscar fretes:', error)
      setFeedback({
        isOpen: true,
        message: 'Erro ao carregar fretes!',
        statusOk: false,
      })
      return []
    }
  }

  const deleteFreight = async (id: number) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/router/freight/${id}`,
      )
      setFreights((prevFreights) =>
        prevFreights.filter((freight) => freight.id !== id),
      )
      setFeedback({
        isOpen: true,
        message: 'Frete deletado!',
        statusOk: true,
      })
    } catch {
      setFeedback({
        isOpen: true,
        message: 'Erro ao deletar frete',
        statusOk: false,
      })
    }
  }

  const loadMoreFreights = async () => {
    if (!hasMore) {
      return
    }

    try {
      const nextPage = page + 1
      const newFreights = await getFreights(
        nextPage,
        freightStatusFilter,
        search,
      )

      if (newFreights.length === 0 || newFreights.length < 50) {
        setHasMore(false)
      }
      setFreights((prevFreights) => [...prevFreights, ...newFreights])
      setPage(nextPage)
    } catch (error) {
      setFeedback({
        isOpen: true,
        message: 'Erro ao carregar mais fretes',
        statusOk: false,
      })
    }
  }

  useEffect(() => {
    const fetchInitialFreights = async () => {
      try {
        setPage(0)
        setHasMore(true)
        const initialFreights = await getFreights(
          0,
          freightStatusFilter,
          search,
        )
        setFreights(initialFreights)
        if (initialFreights.length < 50) {
          setHasMore(false)
        }
      } catch (error) {
        setFeedback({
          isOpen: true,
          message: 'Erro ao carregar fretes iniciais',
          statusOk: false,
        })
        setFreights([])
      }
    }
    fetchInitialFreights()
  }, [freightStatusFilter, search, appliedFilters])

  const { setTabIndex } = useOutletContext<RouterOutletType>()

  useEffect(() => {
    setTabIndex(0)
    setRouterSection('freight')
  }, [])

  const mapStatus = (status: string): string => {
    if (status === 'A programar') return ''
    if (status === 'Rota programada') return 'pending'
    if (status === 'Endereço pendente' || status === 'Cancelado')
      return 'cancel'
    if (status === 'Entregue' || status === 'Coletado') return 'completed'
    return status
  }

  const filteredFreights = useMemo(() => {
    return freights
  }, [freights])

  return (
    <>
      <TableContainer>
        <GlobalTable>
          <thead>
            <HeaderLine>
              {headerFreightTable.map((header) => (
                <Th key={header}>{header}</Th>
              ))}
              <Th></Th>
            </HeaderLine>
          </thead>
          <tbody>
            {filteredFreights.map((item, rowIndex) => {
              const isDuplicate = duplicatedIds.includes(item.id!)
              const rowStyle = isDuplicate ? { backgroundColor: '#fffbe3' } : {}

              return (
                <Tr
                  key={item.id}
                  title={`Criado${
                    item.createdBy ? ' por: ' + item.createdBy.name : ''
                  } ${item.createdAt ? dateHourFormatter(item.createdAt) : ''}`}
                  style={rowStyle}
                >
                  <Td>
                    {item.Company?.companyName
                      .split(/\s|-/)
                      .slice(0, 2)
                      .join(' ') + '...'}
                  </Td>

                  <Td>{item.type}</Td>
                  <Td>
                    <StatusText className={mapStatus(item.status)}>
                      {item.status}
                    </StatusText>
                  </Td>
                  <Td>
                    {item.readyToShip
                      ? new Date(item.readyToShip).setUTCHours(0, 0, 0, 0) <=
                        new Date().setUTCHours(0, 0, 0, 0)
                        ? 'Liberado'
                        : dataFormatter(item.readyToShip)
                      : ''}
                  </Td>

                  <Td>{item.deadLine ? dataFormatter(item.deadLine) : ''}</Td>

                  <Td>
                    {item.observation
                      ? item.observation
                          .replace(/\[CÓPIA\]/gi, '')
                          .substring(0, 25)
                          .trim()
                      : ''}
                  </Td>

                  <TdButtons>
                    <OptionsImage
                      onClick={async () => await handleViewFreight(item.id!)}
                      src={details}
                      alt='Icon to show freight'
                    />
                    <OptionsImage
                      onClick={async () => await handleEditFreight(item.id!)}
                      src={edit}
                      alt='Icon to edit freight'
                    />
                    <OptionsImage
                      onClick={async () => await deleteFreight(item.id!)}
                      src={trash}
                      alt='Icon to delete freight'
                    />
                  </TdButtons>
                  {/* <ImageCell>
              <OptionsImage onClick={async () => await handleViewFreight(item.id)} src={details} alt='Icon to show freight' />
            </ImageCell>
            <ImageCell>
              <OptionsImage onClick={async () => await handleEditFreight(item.id)} src={edit} alt='Icon to edit freight' />
            </ImageCell>
            <ImageCell>
              <OptionsImage onClick={async () => await deleteFreight(item.id)} src={trash} alt='Icon to delete freight' />
            </ImageCell> */}
                </Tr>
              )})}
          </tbody>
        </GlobalTable>
        <LoadMoreButton
          onLoadMore={loadMoreFreights}
          currentCount={freights.length}
          hasMore={hasMore}
          totalCount={totalFreights}
        />
      </TableContainer>
    </>
  )
}

export default FreightTable